/**
 * Veřejný přístup — ACM control-plane only (widget-first 2.1).
 *
 * Hlavní panel: NodeServicesCard (services_state / service_public / service_sso).
 * ACL: kdo smí k publikovanému ACM.
 * Domains / master key: platform konfigurace.
 * Neobsahuje publish app na ACM — to je Network + owner moduly.
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('acm-self');

export default function AcmSelfPage() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='services' />;
}

/** Pro system-settings Access tab — stejné panely. */
export { AclPanel, ServicesPanel } from './acm-self/panels';
